import { css } from 'glamor';

import { RED } from 'depop/styles/colors';
import { FAMILY_STANDARD } from 'depop/styles/typography';

// TODO: Source the assets url from config
const assetBaseURL = 'https://d3170a3msf25m.cloudfront.net/assets';

const GT_AMERICA_EXTENDED_BOLD_WOFF2 = `${assetBaseURL}/GT-America-Extended-Bold.woff2`;
const GT_AMERICA_EXTENDED_BOLD_WOFF  = `${assetBaseURL}/GT-America-Extended-Bold.woff`;

const GT_AMERICA_EXTENDED_REGULAR_EOT   = `${assetBaseURL}/GTAmerica-ExtendedRegular.eot`;
const GT_AMERICA_EXTENDED_REGULAR_WOFF2 = `${assetBaseURL}/GTAmerica-ExtendedRegular.woff2`;
const GT_AMERICA_EXTENDED_REGULAR_WOFF  = `${assetBaseURL}/GTAmerica-ExtendedRegular.woff`;
const GT_AMERICA_EXTENDED_REGULAR_TTF   = `${assetBaseURL}/GTAmerica-ExtendedRegular.ttf`;

const GT_AMERICA_STANDARD_BOLD_EOT   = `${assetBaseURL}/GTAmerica-Bold.eot`;
const GT_AMERICA_STANDARD_BOLD_WOFF2 = `${assetBaseURL}/GTAmerica-Bold.woff2`;
const GT_AMERICA_STANDARD_BOLD_WOFF  = `${assetBaseURL}/GTAmerica-Bold.woff`;
const GT_AMERICA_STANDARD_BOLD_TTF   = `${assetBaseURL}/GTAmerica-Bold.ttf`;

const GT_AMERICA_STANDARD_REGULAR_EOT   = `${assetBaseURL}/GTAmerica-Regular.eot`;
const GT_AMERICA_STANDARD_REGULAR_WOFF2 = `${assetBaseURL}/GTAmerica-Regular.woff2`;
const GT_AMERICA_STANDARD_REGULAR_WOFF  = `${assetBaseURL}/GTAmerica-Regular.woff`;
const GT_AMERICA_STANDARD_REGULAR_TTF   = `${assetBaseURL}/GTAmerica-Regular.ttf`;


export default function applyRootStyles() {

  css.insert(`
  @font-face {
    font-family: 'GT America Extended Bold';
    src: url('${GT_AMERICA_EXTENDED_BOLD_WOFF2}') format('woff2'),
         url('${GT_AMERICA_EXTENDED_BOLD_WOFF}') format('woff');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'GT America Extended Regular';
    src: url('${GT_AMERICA_EXTENDED_REGULAR_EOT}');
    src: url('${GT_AMERICA_EXTENDED_REGULAR_EOT}?#iefix') format('embedded-opentype'),
         url('${GT_AMERICA_EXTENDED_REGULAR_WOFF2}') format('woff2'),
         url('${GT_AMERICA_EXTENDED_REGULAR_WOFF}') format('woff'),
         url('${GT_AMERICA_EXTENDED_REGULAR_TTF}') format('truetype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'GT America Standard Bold';
    src: url('${GT_AMERICA_STANDARD_BOLD_EOT}');
    src: url('${GT_AMERICA_STANDARD_BOLD_EOT}?#iefix') format('embedded-opentype'),
         url('${GT_AMERICA_STANDARD_BOLD_WOFF2}') format('woff2'),
         url('${GT_AMERICA_STANDARD_BOLD_WOFF}') format('woff'),
         url('${GT_AMERICA_STANDARD_BOLD_TTF}') format('truetype');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'GT America Standard Regular';
    src: url('${GT_AMERICA_STANDARD_REGULAR_EOT}');
    src: url('${GT_AMERICA_STANDARD_REGULAR_EOT}?#iefix') format('embedded-opentype'),
         url('${GT_AMERICA_STANDARD_REGULAR_WOFF2}') format('woff2'),
         url('${GT_AMERICA_STANDARD_REGULAR_WOFF}') format('woff'),
         url('${GT_AMERICA_STANDARD_REGULAR_TTF}') format('truetype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }
  `);

  css.insert(`html, body, div, span, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  abbr, address, cite, code,
  del, dfn, em, img, ins, kbd, q, samp,
  small, strong, sub, sup, var,
  b, i,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section, summary,
  time, mark, audio, video {
    margin:0;
    padding:0;
    border:0;
    outline:0;
    font-size:100%;
    vertical-align:baseline;
    background:transparent;
  }`);

  css.insert(`body {
    line-height:1;
    padding-right:0px !important;
    margin-right:0px !important;
  }`);

  css.insert(`article,aside,details,figcaption,figure,
  footer,header,hgroup,menu,nav,section {
    display:block;
  }`);

  css.insert(`nav ul {
    list-style:none;
  }`);

  css.insert(`
  @keyframes fadeIn {
    0% { opacity: 0; }
    50% { opacity: 0; }
    100% { opacity: 100%; }
  }

  .fade-in {
    animation: fadeIn 150ms ease-in;
    animation-iteration-count: 1;
  }`);

  css.insert(`a {
    margin:0;
    padding:0;
    font-size:100%;
    vertical-align:baseline;
    background:transparent;
  }`);

  css.insert(`table {
    border-collapse:collapse;
    border-spacing:0;
  }`);

  css.insert(`hr {
    display:block;
    height:1px;
    border:0;
    border-top:1px solid #cccccc;
    margin:1em 0;
    padding:0;
  }`);

  css.insert(`input, select {
    vertical-align:middle;
  }`);

  css.insert(`
  html {
    box-sizing: border-box;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  html,
  body {
    margin: 0;
    padding: 0;
    height: 100%;
    font-family: ${FAMILY_STANDARD};
    font-size: 16px;
    background: white;
  }

  #mount {
    height: 100%;
  }
  `);

  css.insert(`input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 10000px white inset;
  }`);

  css.insert(`#nprogress {
    pointer-events: none;
  }`);

  css.insert(`#nprogress .bar {
    background: ${RED};

    position: fixed;
    z-index: 1031;
    top: 0;
    left: 0;

    width: 100%;
    height: 2px;
  }`);

  css.insert(`#nprogress .peg {
    display: block;
    position: absolute;
    right: 0px;
    width: 100px;
    height: 100%;
    opacity: 1.0;
    transform: rotate(3deg) translate(0px, -4px);
  }`);
}



// WEBPACK FOOTER //
// ../src/client/utils/applyRootStyles.js